import { navigate } from 'gatsby';
import * as React from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import '../styles/timeline.scss';
import ReactMarkdown from 'react-markdown';

function HowItWorks({ heading, description, actionBtn, actionSlug, steps }) {
  return (
    <section>
      <h2>{heading}</h2>
      <ReactMarkdown>{description}</ReactMarkdown>
      <div className='center'>
        <button onClick={() => navigate(`/${actionSlug}#header`)}>
          {actionBtn}
        </button>
      </div>

      <VerticalTimeline>
        {steps?.map((step, i) => (
          <VerticalTimelineElement key={i} id={`step${i + 1}`}>
            <img
              alt='icon'
              className='card-icon'
              src={step.icon.url}
              width={100}
            />
            <h3 className='vertical-timeline-element-title'>{`${i + 1}. ${
              step.heading
            }`}</h3>
            <ReactMarkdown>{step.description}</ReactMarkdown>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </section>
  );
}
export default HowItWorks;
